export default __webpack_public_path__ + "static/media/chevron right.7bf144ef.svg";